import { untilDestroyed } from '@ngneat/until-destroy';
import { AppModes, AppService } from '@shared/services/app.service';

export interface IGetModeContext {
  appService: AppService;
  appMode: AppModes;
}

export const GetAppMode = (context: IGetModeContext, callback?: (appMode: AppModes) => any) => {
  context.appService.appMode$.pipe(untilDestroyed(context)).subscribe({
    next: (data) => {
      context.appMode = data;
      if (callback) {
        callback(data);
      }
    },
  });
};
